import { useEffect, useRef, useState } from 'react';

// 여기에 원하는 비밀번호를 설정하세요
const PROTOTYPE_PASSWORD = 'dalock2026!@#';

interface PasswordGateProps {
  children: React.ReactNode;
}

export const PasswordGate = ({ children }: PasswordGateProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const stored = sessionStorage.getItem('prototype_auth');
    if (stored === 'true') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      inputRef.current?.focus();
    }
  }, [isLoading, isAuthenticated]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === PROTOTYPE_PASSWORD) {
      sessionStorage.setItem('prototype_auth', 'true');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('비밀번호가 올바르지 않습니다.');
      setPassword('');
    }
  };

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <div className="flex justify-center items-center p-4 min-h-screen bg-slate-900">
        <div className="p-8 w-full max-w-md bg-white rounded-lg shadow-xl">
          <div className="mb-6 text-center">
            <h1 className="text-2xl font-bold text-slate-800">
              다락 매출 분석 리포트
            </h1>
            <p className="mt-2 text-slate-500">
              프로토타입 접근 권한이 필요합니다
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label
                htmlFor="prototype-password"
                className="block mb-2 text-sm font-medium text-slate-700"
              >
                비밀번호
              </label>
              <input
                ref={inputRef}
                type="password"
                id="prototype-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="px-4 py-3 w-full rounded-lg border transition-all outline-none border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="비밀번호를 입력하세요"
              />
            </div>

            {error && <p className="mb-4 text-sm text-red-500">{error}</p>}

            <button
              type="submit"
              className="py-3 w-full font-medium text-white bg-blue-600 rounded-lg transition-colors hover:bg-blue-700"
            >
              접속하기
            </button>
          </form>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
